import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<File | string>;

export const DispatchSetFileValue: HandlerType = props => {
    if (props.parameter) {
        props.dispatch({
            type: "Components/CreateAccountForm/SetFileValue" as any,
            value: props.parameter as any,
        });
    } else {
        props.dispatch({
            type: "Components/CreateAccountForm/SetFileValue" as any,
            value: "" as any,
        });
    }
};

export const chain = [DispatchSetFileValue];

const setFileValue = createHandlerChainRunner(chain, "SetFileValue");
export default setFileValue;
